import React from 'react'
import {HandlePageWelcome} from '../../../../../context/HandlePageWelcome'
import {MDBBtn} from 'mdb-react-ui-kit'
import {AiFillCaretLeft, AiFillCaretRight} from 'react-icons/ai'
import {RiVipCrownLine} from 'react-icons/ri'
import {Link} from 'react-router-dom'

const LevelThree = () => {
  const {page, setPage} = React.useContext(HandlePageWelcome)
  return (
    <div style={{ height: '90%' }} dir={'rtl'} className={'flex mt-5 flex-col justify-between'}>
      <div className={'mt-5'}>
        <h1 className={'text-white text-5xl '}>باشگاه VIP سهامداران</h1>
        <br />
        <hr className={'bg-white  h-5'} />
      </div>
      <div className={'text-center'}>
        <RiVipCrownLine className={'text-white '} size={150} />

      </div>
      <div>
        <p className={'text-white bk-light  text-2xl font-light'}>
          تمامی سهام داران بیمارستان و اعضای خانوادشان ( همسر و فرزند ) به صورت خاص در باشگاه وی ای پی عضو شده که این تسهیلات ویژه شامل:
        </p>
        <div className={'text-white mt-5 mb-2'}>
          <ul className={'leading-9'}>
            <li>تخفیف در هزینه درمان</li>
            <li>  بیمه مکمل درمان  برای سهمامدار</li>
            <li>معاینات سالیانه سهمامدار </li>
            <li>خدمات رفاهی و...</li>
          </ul>
        </div>
      </div>

      <div className={'flex justify-between'}>
        <MDBBtn color='light' outline  className={'rounded-lg'}  onClick={() => setPage(2)}>
          <AiFillCaretRight />
          مرحله قبل
        </MDBBtn>
        {/* <Link to={'/auth/login'}>
          <MDBBtn color='light'   className={'rounded-lg'} >
            خرید سهام
            <AiFillCaretLeft />
          </MDBBtn>
        </Link> */}

      </div>
    </div>
  )
}

export default LevelThree
